import MaskedInput from "react-input-mask"
import { useController } from "react-hook-form"
import mergeDeep from "@mobi/utils/object/mergeDeep"

import { Input } from "@mobi/ds"
import { handleChange, handleBlur } from "../../handlerMethods"

const DEFAULT_MESSAGES = {
  required: "campo obrigatório",
}

const Text = ({
  name = "",
  label,
  type = "text",
  control,
  required = true,
  validators: { rules: propRules = {}, messages: propMessages = {} } = {},
  onChange = () => null,
  onBlur = () => null,
  ...props
}) => {
  const rules = mergeDeep(propRules, { required })

  const errorMessages = mergeDeep(DEFAULT_MESSAGES, propMessages)
  const {
    field,
    fieldState: { invalid, error, isTouched, isDirty },
  } = useController({ name, control, rules })

  const isInvalid = isTouched && invalid && isDirty

  return (
    <Input.Default
      {...props}
      value={field.value}
      name={field.name}
      onChange={(event) => handleChange(event, field, onChange)}
      onBlur={(event) => handleBlur(event, field, onBlur)}
      label={label}
      type={type}
      isValid={!isInvalid}
      errorMessage={errorMessages[error?.type]}
      aria-required={required}
    />
  )
}

export default Text
